import { MyThunkResult } from 'store';

import { hotelLocationsSuccessful, hotelLocationsError, hotelLocationsRequest } from 'action-creators/hotelLocations';
import { TravelHotelSearchResponse } from 'models/hotelLocation';
import { getCurrentLanguage } from 'utils/generic';
import { getLanguageWithoutRegion } from 'utils/i18n';

import { axiosConfig, rappiServicesTravelSearchHotels } from '../api';

export const searchHotelLocations = (text: string): MyThunkResult<Promise<void>> => async (dispatch, getState) => {
  try {
    dispatch(hotelLocationsRequest());
    const { country } = getState().i18n;
    const currentLanguage = country ? getLanguageWithoutRegion(getCurrentLanguage()) : 'ES';
    const countryId = getState().user.accountResult?.countryId ?? '';

    const { data } = await rappiServicesTravelSearchHotels.get<TravelHotelSearchResponse>('', {
      params: {
        query: text.sanitize(),
        lang: currentLanguage.toUpperCase(),
        country: countryId,
        limit: 10,
      },
      ...axiosConfig,
    });

    dispatch(hotelLocationsSuccessful(data));
  } catch (ex) {
    dispatch(hotelLocationsError(ex));
  }
};
